import { Quote } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { IMAGES } from "../data/resources";

const EXAMPLE_STORY = {
  name: "A sister like you",
  title: "Example — shared to show the heart of this space",
  text: "I came carrying more than I could name. Nobody rushed me, nobody fixed me — they just made room. Week by week, the worry got quieter and the worship got louder. That's what this sisterhood is for.",
};

export default function Stories() {
  return (
    <main data-testid="stories-page">
      <section className="relative overflow-hidden">
        <img
          src={IMAGES.heroTexture}
          alt=""
          className="texture-image pointer-events-none absolute inset-0 h-full w-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-espresso/70 to-espresso" />
        <div className="relative mx-auto max-w-7xl px-6 py-28 sm:py-36">
          <Reveal>
            <p className="eyebrow">Stories</p>
            <h1 className="mt-6 max-w-3xl font-serif text-4xl font-light leading-[1.1] text-cream sm:text-5xl lg:text-6xl">
              Worry, set down. <em className="text-softgold">In their own words.</em>
            </h1>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-parchment/85 md:text-lg">
              This page is being written by real women right now. Stories are
              shared only with written permission and care — below is an example
              of the kind of testimony this space will hold.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-espresso">
        <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32">
          <Reveal className="mx-auto max-w-3xl">
            <figure
              data-testid="story-example"
              className="flex flex-col rounded-2xl border border-gold/30 bg-plum/50 p-8 sm:p-12"
            >
              <span className="w-fit rounded-full border border-gold/40 px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.25em] text-gold">
                Example Story
              </span>
              <Quote className="mt-6 h-7 w-7 text-softgold/60" aria-hidden="true" />
              <blockquote className="mt-5 flex-1 font-serif text-xl font-light italic leading-relaxed text-cream/95 sm:text-2xl">
                "{EXAMPLE_STORY.text}"
              </blockquote>
              <figcaption className="mt-8 border-t border-white/10 pt-5">
                <span className="text-sm font-bold uppercase tracking-[0.2em] text-softgold">{EXAMPLE_STORY.name}</span>
                <span className="mt-1 block text-xs text-parchment/60">{EXAMPLE_STORY.title}</span>
              </figcaption>
            </figure>
          </Reveal>
          <Reveal delay={0.1} className="mx-auto mt-14 max-w-2xl text-center">
            <p className="font-garamond text-2xl font-light italic leading-relaxed text-parchment/80 sm:text-3xl">
              Real stories are coming — written by sisters, shared only with
              their blessing.
            </p>
            <p className="mt-6 text-sm leading-relaxed text-parchment/65">
              Have a story of worry set down? We'd be honored to hear it — nothing
              is ever published without your written permission.
            </p>
            <a
              href="mailto:hello@sheworriers.org?subject=My%20Story"
              data-testid="share-story-cta"
              className="mt-8 inline-flex items-center gap-2 rounded-full border border-gold/60 px-8 py-3.5 text-xs font-bold uppercase tracking-[0.22em] text-gold transition-all duration-300 hover:bg-gold hover:text-ink"
            >
              Share Your Story
            </a>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
